import React from "react";
import { Outlet } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import { SharedDataProvider } from "../context/sharedDataContext";

const ProtectedRoute = () => {
  return (
    <PrivateRoute>
      <SharedDataProvider>
        <Outlet />
      </SharedDataProvider>
    </PrivateRoute>
  );
};

export default ProtectedRoute;
